import queryString from 'query-string';

import { createAxiosInstance } from '~/plugins/axios.plugin';

export class UserService {
  static SERVICE_NAME = 'user';

  constructor() {
    this.client = createAxiosInstance({
      baseURL        : process.env.PLATAFORMA_API,
      useAccessToken : true
    });
  }

  getUserById(id) {
    return this.client.get(`/users/${id}`);
  }

  getAllUsers({ perPage, page, filter, status, sortBy, order }) {
    return this.client.get('/users', { params: { perPage, page, filter, status, sortBy, order } });
  }

  postUser(body) {
    return this.client.post('/users', body);
  }

  patchUser({ id, ...data }) {
    return this.client.patch(`/users/${id}`, data);
  }

  getAllAccessibilities() {
    return this.client.get('/settings/accessibilities');
  }

  updateByUserPhoto({ id, ...body }) {
    return this.client.put(`/users/${id}/photo`, body);
  }

  getCategories(id) {
    return this.client.get(`/users/${id}/category`);
  }

  patchCategories({ id, ...body }) {
    return this.client.patch(`/users/${id}/category`, body.body);
  }

  getUserEnrollments({ id, page, perPage, order, orderBy, name, filterPeriodId, categoriesIds, status }) {
    const stringified = queryString.stringify({ page, perPage, order, orderBy, name, filterPeriodId, categoriesIds, status }, { skipNull: true, skipEmptyString: true });
    return this.client.get(`/users/${id}/enrollment${stringified && `?${stringified}`}`);
  }

  editUserEnrollment({ id, enrollmentId, enrollmentStatusId, roleCourseId }) {
    return this.client.put(`/users/${id}/enrollment/${enrollmentId}`, { enrollmentStatusId, roleCourseId });
  }

  getUserRolesContext() {
    return this.client.get('/users/roles/me');
  }

  getSafeARoles() {
    return this.client.get('/users/roles/safea');
  }

  editUserPassword({ id, password, applicationUrl }) {
    return this.client.put(`/users/${id}/password`, { password, applicationUrl });
  }
}

export default new UserService();
